import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import '../../styles/common/AdminPageFilters.css';

const AdminPageFilters = ({ 
  children,
  className = ''
}) => {
  return (
    <div className={`admin-page-filters ${className}`}>
      {children}
    </div>
  );
};

// Sub-components for consistent filter structure
const FilterGroup = ({ children, className = '' }) => (
  <div className={`filter-group ${className}`}>
    {children}
  </div>
);

const TabGroup = ({ activeTab, onTabChange, tabs, className = '' }) => (
  <div className={`tab-group ${className}`}>
    {tabs.map(tab => (
      <button
        key={tab.key}
        className={`tab ${activeTab === tab.key ? 'active' : ''}`}
        onClick={() => onTabChange(tab.key)}
      >
        {tab.label}
      </button>
    ))}
  </div>
);

const SearchBox = React.memo(({ 
  value, 
  onChange, 
  placeholder = "Search...", 
  className = '' 
}) => (
  <div className={`search-box ${className}`}>
    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
      <FontAwesomeIcon 
        icon={faSearch} 
        className="h-4 w-4 text-gray-400" 
        aria-hidden="true" 
      />
    </div>
    <input
      type="text"
      placeholder={placeholder}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
    />
  </div>
));

const SortDropdown = ({ 
  value, 
  onChange, 
  options, 
  className = '' 
}) => (
  <div className={`sort-dropdown ${className}`}>
    <select 
      value={value} 
      onChange={(e) => onChange(e.target.value)}
      className="sort-select"
    >
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
);

// Export sub-components
AdminPageFilters.FilterGroup = FilterGroup;
AdminPageFilters.TabGroup = TabGroup;
AdminPageFilters.SearchBox = SearchBox;
AdminPageFilters.SortDropdown = SortDropdown;

export default AdminPageFilters;
